import { getCookie } from "@/lib/shared/useCookies"
import { wildcardMatch } from "@/lib/wildcardMatch"
import { computed, ref, watch } from "vue"
import { useRoute } from "vue-router"

interface Data {
  title: string
  message: string
  pages: string[]
}

const defaultData: Partial<Data> = {
  title: "Under maintenance",
  message:
    "We are doing some essential maintenance on our website. We apologise for any inconvenience this may cause.",
}

const maintenanceCookieKey = "website_maintenanceBanner"

export function usePageLevelMaintenance() {
  const route = useRoute()
  const data = ref<Data>()
  const isUnderMaintenance = computed(() => !!data.value)

  const update = () => {
    const maintenanceCookie = getCookie(maintenanceCookieKey)

    const isCurrentPageAffected = maintenanceCookie?.pages?.some(
      (page: string) => wildcardMatch(page, location.pathname),
    )

    data.value = isCurrentPageAffected
      ? {
          ...defaultData,
          ...maintenanceCookie,
        }
      : undefined
  }

  watch(() => route.path, update, { immediate: true })

  return {
    data,
    isUnderMaintenance,
  }
}
